import { render } from "./ProjectDashboardView.vue?vue&type=template&id=75da1bb4&scoped=true&ts=true"
import script from "./ProjectDashboardView.vue?vue&type=script&lang=ts"
export * from "./ProjectDashboardView.vue?vue&type=script&lang=ts"

import "./ProjectDashboardView.vue?vue&type=style&index=0&id=75da1bb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75da1bb4"]])

export default __exports__